module.exports = __webpack_public_path__ + "static/media/appleTVWhite.f9c52939.svg";